module.exports = __webpack_public_path__ + "static/media/MuhammadUmerKhalid.2b9116c1.jpeg";